import { gql } from '@apollo/client';

export const UPSERT_USER_PREFERENCE = gql`
  mutation UpsertUserPreference(
    $preferenceType: String!
    $preferenceKey: String!
    $preferences: String!
  ) {
    upsertUserPreference(
      preferenceType: $preferenceType
      preferenceKey: $preferenceKey
      preferences: $preferences
    ) {
      userPreference {
        preferenceType
        preferenceKey
        preferences
      }
      errors {
        path
        message
      }
    }
  }
`;
